var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 431,
    height: 440,
    viewBox: "0 0 431 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291.272 87.8629L139.71 87.8697C134.377 87.8699 130.055 92.1931 130.055 97.5259C130.056 102.859 134.379 107.181 139.712 107.181L291.274 107.174C296.607 107.174 300.93 102.851 300.929 97.5183C300.929 92.1855 296.605 87.8627 291.272 87.8629Z",
    fill: "#004416"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291.288 332.813L139.727 332.82C134.394 332.82 130.071 337.144 130.072 342.476C130.072 347.809 134.396 352.132 139.729 352.132L291.29 352.125C296.623 352.125 300.946 347.802 300.945 342.469C300.945 337.136 296.621 332.813 291.288 332.813Z",
    fill: "#004416"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.502 220C254.833 198.06 281.297 195.959 281.294 148.998L281.291 107.172L149.698 107.182L149.701 149.007C149.704 195.968 176.169 198.065 215.502 220Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.194 204.826L190.772 149.18L171.804 135.655L149.697 107.182L149.699 149.007C149.702 195.969 176.167 198.065 215.5 220C226.505 213.862 236.502 209.275 245.194 204.826Z",
    fill: "#81E791"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.305 290.994C281.302 244.033 254.838 241.936 215.504 220.001C176.173 241.942 149.71 244.042 149.712 291.003L149.715 332.829L281.307 332.82L281.305 290.994Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.305 332.818L185.808 235.174C163.434 246.627 149.708 257.18 149.71 291.002L149.713 332.827L281.305 332.818Z",
    fill: "#81E791"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.212 332.822C197.623 301.844 188.822 268.729 185.808 235.174C163.434 246.627 149.708 257.18 149.71 291.002L149.713 332.827L212.212 332.822Z",
    fill: "#00BF00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.701 149.005C149.703 182.249 162.966 193.01 184.668 204.243C185.191 171.282 191.261 138.397 202.879 107.176L149.699 107.18L149.701 149.005Z",
    fill: "#D6D6D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.666 204.245C184.959 185.773 186.994 167.326 190.772 149.18L149.697 107.182L149.699 149.007C149.701 182.251 162.965 193.013 184.666 204.245Z",
    fill: "#00BF00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M291.485 87.8651L139.496 87.8717C134.281 87.8719 130.054 92.1952 130.055 97.528C130.056 102.861 134.283 107.184 139.498 107.183L291.487 107.177C296.702 107.177 300.929 102.853 300.929 97.5206C300.928 92.1878 296.7 87.8649 291.485 87.8651Z",
    stroke: "#00004E",
    strokeWidth: 4.13687,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M281.291 109.991L281.294 148.999C281.297 195.96 254.834 198.06 215.503 220.001C176.169 198.066 149.705 195.969 149.702 149.008L149.699 109.999",
    stroke: "#00004E",
    strokeWidth: 4.13687,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M281.304 330.471L281.301 290.993C281.298 244.032 254.834 241.935 215.5 220C176.169 241.94 149.706 244.041 149.708 291.002L149.711 330.479",
    stroke: "#00004E",
    strokeWidth: 4.13687,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M291.501 332.815L139.513 332.822C134.298 332.822 130.071 337.146 130.071 342.479C130.072 347.812 134.3 352.135 139.515 352.134L291.503 352.128C296.718 352.128 300.945 347.804 300.945 342.471C300.944 337.138 296.716 332.815 291.501 332.815Z",
    stroke: "#00004E",
    strokeWidth: 4.13687,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingPlaceholder);
export default __webpack_public_path__ + "static/media/loading_placeholder.e013825d.svg";
export { ForwardRef as ReactComponent };